import { NoddiSkeleton } from 'noddi-ui-web';
import { DayTabList } from './DayTabList';
import { TIME_WINDOW_DAYS_PER_PAGE } from './utils';

const SKELETON_ROW_COUNT = 6;

type Props = {
  /** `tabs`: one row of day tabs over one day's windows (phone). `columns`: a column of windows per day. */
  layout: 'tabs' | 'columns';
  /** The tabs' card stays put while a page loads, so paging does not reflow the screen. */
  isOnPage: boolean;
  loadingLabel: string;
};

export const TimeWindowGridSkeleton = ({ layout, isOnPage, loadingLabel }: Props) => {
  const dayHeaders = Array.from({ length: TIME_WINDOW_DAYS_PER_PAGE }).map((_, index) => (
    <div key={index} className='flex flex-1 flex-col items-center gap-1 pt-2 pb-2.5'>
      <NoddiSkeleton className='h-4 w-10' />
      <NoddiSkeleton className='size-6' />
      <NoddiSkeleton className='h-3 w-12' />
    </div>
  ));
  const rows = Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
    <NoddiSkeleton key={index} className='mx-auto h-14 w-full rounded-lg' />
  ));

  if (layout === 'tabs') {
    return (
      <div className='flex flex-col gap-5' role='status'>
        <span className='sr-only'>{loadingLabel}</span>
        <DayTabList isOnPage={isOnPage}>{dayHeaders}</DayTabList>
        <div className='flex flex-col gap-2'>{rows}</div>
      </div>
    );
  }

  return (
    <div className='grid grid-cols-5 gap-6' role='status'>
      <span className='sr-only'>{loadingLabel}</span>
      {dayHeaders.map((header, index) => (
        <div key={index} className='flex min-w-0 flex-col'>
          {header}
          <div className='flex flex-col gap-2 pt-3 *:max-w-32'>{rows}</div>
        </div>
      ))}
    </div>
  );
};
